import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { CMS } from '../../../utils/CMS';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import { KidsDropdownItem } from './KidsDropdownItem';

const KidsDropdownSelector = ({ value, list, onSelectKidAge, showKidError }) => {
    const node = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    const toggle = () => setOpen(!open);

    const handleChange = (value) => {
        onSelectKidAge(value);
        setOpen(false);
    };

    const classNamesInput = className({
        'odf-input-group': true,
        'invalid': showKidError && value === -1,
    });
    const classNamesArrow = className({
        'odf-input-append odf-icon': true,
        'odf-icon-arrow-up': open,
        'odf-icon-arrow-down': !open,
    });
    return (
        <div
            className={classNamesInput}
            data-testid="kids-dropdown"
            ref={node}
        >
            <div className='odf-input odf-select' onClick={toggle}>
                <div className='odf-text-md'>
                    <CMS id="roomSelector.dropdown.text" />{value !== -1 ? ': ' + value : ''}
                </div>
                <span className={classNamesArrow} />
            </div>
            <Dropdown open={open} onClose={() => setOpen(false)} parentRef={node}>
                <ul className="odf-dropdown open">
                    { list.map((item) => (
                        <KidsDropdownItem key={item} value={item} onChange={handleChange} />
                    )) }
                </ul>
            </Dropdown>
        </div>
    );
};

KidsDropdownSelector.propTypes = {
    value: PropTypes.number.isRequired,
    list: PropTypes.arrayOf(PropTypes.number).isRequired,
    onSelectKidAge: PropTypes.func.isRequired,
    showKidError: PropTypes.bool.isRequired,
};

export { KidsDropdownSelector };
